import { render, staticRenderFns } from "./SchoolLiveDashboard.vue?vue&type=template&id=bef1449c&scoped=true"
import script from "./SchoolLiveDashboard.vue?vue&type=script&lang=js"
export * from "./SchoolLiveDashboard.vue?vue&type=script&lang=js"
import style0 from "./SchoolLiveDashboard.vue?vue&type=style&index=0&id=bef1449c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef1449c",
  null
  
)

export default component.exports